angular.module('mandaeApp')
  .directive('logout', function () {
    'use strict';
    return {
      scope: true,
      bindToController: {
        showLoading: '=',
        trackingEvents: '=',
      },
      restrict: 'E',
      template:
        ['<a title="Sair" ng-click="ctrl.handleClick()" class="btn btn-exit btn-exit--fixed">',
          '<span class="logout-icon display-inline-block"></span>',
          '<span class="btn-exit-text">Sair</span>',
          '<img class="loading" src="/assets/images/loading.svg" ng-show="ctrl.showLoading">',
        '</a>'].join(''),
      controllerAs: 'ctrl',
      controller: ['$scope', '$window', 'Auth', function ($scope, $window, Auth) {
        this.handleClick = function () {
          this.showLoading = true;
          Auth.logout(this.trackingEvents)
            .then(function() {
              $window.location.href = '/';
            })
            .catch(function(err) {
              $scope.error = err.data;
            });
        };
      }],
    };
  });
